var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.375H9.625V13.75H5.5V12.375ZM5.5 15.125H12.375V16.5H5.5V15.125Z",
    fill: "#77787B",
    stroke: "#77787B",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 2.75H4.125C3.76049 2.75055 3.41107 2.89559 3.15333 3.15333C2.89559 3.41107 2.75055 3.76049 2.75 4.125V17.875C2.75055 18.2395 2.89559 18.5889 3.15333 18.8467C3.41107 19.1044 3.76049 19.2495 4.125 19.25H17.875C18.2395 19.2495 18.5889 19.1044 18.8467 18.8467C19.1044 18.5889 19.2495 18.2395 19.25 17.875V4.125C19.2495 3.76049 19.1044 3.41107 18.8467 3.15333C18.5889 2.89559 18.2395 2.75055 17.875 2.75ZM12.375 4.125V6.875H9.625V4.125H12.375ZM4.125 17.875V4.125H8.25V8.25H13.75V4.125H17.875L17.8757 17.875H4.125Z",
    fill: "#77787B",
    stroke: "#77787B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonProduct);
export default __webpack_public_path__ + "static/media/carbon_product.25836546dd67480ebed1f68ba4b6bb5d.svg";
export { ForwardRef as ReactComponent };